// export default {
//  appName: 'Events Manager',
//  siteName: 'FiestaisMadrid',
//  siteURL: 'https://quality.fiestaismadrid.net',
//  apiURI: 'https://quality.fiestaismadrid.net',
//  googleMapsToken: 'AIzaSyDjZAjwwH6jSZch6q2lEKQpmIAnzLTxkEU',
//  defaultPage: '/dashboard',
//  defaultLanguage: 'es_ES'
// }


const config = {
    appName: 'Events Manager',
    siteName: 'FiestaisMadrid',
    siteURL: 'https://quality.fiestaismadrid.net',
    apiURI: 'https://quality.fiestaismadrid.net',
    googleMapsToken: 'AIzaSyDjZAjwwH6jSZch6q2lEKQpmIAnzLTxkEU',
    defaultPage: '/dashboard',
    defaultLanguage: 'es_ES'
};

export default config;
